import React, { useState, useEffect, useRef } from 'react';
import { databaseService } from '../../services/databaseService';

const ParkManager = () => {
  const [parks, setParks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [search, setSearch] = useState('');
  const [selPark, setSelPark] = useState(null);
  const [parkDetail, setParkDetail] = useState(null);
  const [parkArea, setParkArea] = useState(null);
  const [parkSurface, setParkSurface] = useState(null);
  const [parkIrrigation, setParkIrrigation] = useState(null);
  const [parkSubs, setParkSubs] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState({});
  const [tab, setTab] = useState('detail');
  const [cmpPark, setCmpPark] = useState(null);
  const [cmpDetail, setCmpDetail] = useState(null);
  const [cmpArea, setCmpArea] = useState(null);
  const [pg, setPg] = useState(0);
  const PS = 50;
  const mapRef = useRef(null);
  const mapInst = useRef(null);

  useEffect(() => { loadParks(); }, [pg]);

  const loadParks = async () => {
    try {
      setLoading(true); setError(null);
      const off = pg * PS;
      let q = `SELECT park_id, name_kmz, name_xls, latitude, longitude FROM water_billing.park ORDER BY park_id LIMIT ${PS} OFFSET ${off}`;
      if (search) {
        const s = search.toLowerCase().replace(/'/g, "''");
        q = `SELECT park_id, name_kmz, name_xls, latitude, longitude FROM water_billing.park WHERE LOWER(COALESCE(name_kmz,'')) LIKE '%${s}%' OR LOWER(COALESCE(name_xls,'')) LIKE '%${s}%' ORDER BY park_id LIMIT ${PS} OFFSET ${off}`;
      }
      const r = await databaseService.executeQuery(q);
      setParks(r.rows || []);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const loadDetail = async (pid) => {
    try {
      setSelPark(pid); setTab('detail'); setEditMode(false);
      const [d, a, sf, ir, sb] = await Promise.all([
        databaseService.executeQuery(`SELECT * FROM water_billing.park WHERE park_id = ${pid}`),
        databaseService.executeQuery(`SELECT * FROM water_billing.park_area WHERE park_id = ${pid}`).catch(() => ({rows:[]})),
        databaseService.executeQuery(`SELECT * FROM water_billing.park_surface_breakdown WHERE park_id = ${pid}`).catch(() => ({rows:[]})),
        databaseService.executeQuery(`SELECT * FROM water_billing.park_irrigation WHERE park_id = ${pid}`).catch(() => ({rows:[]})),
        databaseService.executeQuery(`SELECT s.*, wm.meter_no, wm.diameter FROM water_billing.subscriber s LEFT JOIN water_billing.water_meter wm ON wm.subscriber_id = s.id WHERE s.park_id = ${pid}`).catch(() => ({rows:[]})),
      ]);
      setParkDetail(d.rows[0] || null);
      setParkArea(a.rows[0] || null);
      setParkSurface(sf.rows[0] || null);
      setParkIrrigation(ir.rows[0] || null);
      setParkSubs(sb.rows || []);
      setEditData(d.rows[0] || {});
    } catch (e) { setError(e.message); }
  };

  const loadCmp = async (pid) => {
    try {
      setCmpPark(pid);
      const [d, a] = await Promise.all([
        databaseService.executeQuery(`SELECT * FROM water_billing.park WHERE park_id = ${pid}`),
        databaseService.executeQuery(`SELECT * FROM water_billing.park_area WHERE park_id = ${pid}`).catch(() => ({rows:[]})),
      ]);
      setCmpDetail(d.rows[0] || null);
      setCmpArea(a.rows[0] || null);
    } catch (e) { setError(e.message); }
  };

  const handleSave = async () => {
    try {
      setError(null);
      const sets = [];
      ['name_kmz','name_xls','latitude','longitude'].forEach(k => {
        if (editData[k] !== undefined && String(editData[k]) !== String(parkDetail[k])) {
          if (k === 'latitude' || k === 'longitude') {
            sets.push(`"${k}" = ${editData[k]}`);
          } else {
            const v = String(editData[k]).replace(/'/g, "''");
            sets.push(`"${k}" = '${v}'`);
          }
        }
      });
      if (sets.length === 0) { setEditMode(false); return; }
      await databaseService.executeWriteQuery(`UPDATE water_billing.park SET ${sets.join(', ')} WHERE park_id = ${selPark}`);
      setSuccess('Park guncellendi!');
      setEditMode(false);
      loadDetail(selPark);
      loadParks();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) { setError(e.message); }
  };

  useEffect(() => {
    if (!parkDetail || !mapRef.current) return;
    if (!parkDetail.latitude || !parkDetail.longitude) return;
    if (tab !== 'map' && tab !== 'compare') return;
    if (mapInst.current) { mapInst.current.remove(); mapInst.current = null; }
    const mk = process.env.REACT_APP_MAPTILER_KEY || 'eb6L6NoZoZhWFyDlpOhz';
    if (!window.maplibregl) return;
    const map = new window.maplibregl.Map({
      container: mapRef.current,
      style: `https://api.maptiler.com/maps/satellite/style.json?key=${mk}`,
      center: [parkDetail.longitude, parkDetail.latitude],
      zoom: 17,
    });
    new window.maplibregl.Marker({color:'#ef4444'}).setLngLat([parkDetail.longitude, parkDetail.latitude]).setPopup(new window.maplibregl.Popup().setHTML(`<b>${pName(parkDetail)}</b>`)).addTo(map);
    if (cmpDetail && cmpDetail.latitude && cmpDetail.longitude) {
      new window.maplibregl.Marker({color:'#3b82f6'}).setLngLat([cmpDetail.longitude, cmpDetail.latitude]).setPopup(new window.maplibregl.Popup().setHTML(`<b>${pName(cmpDetail)}</b>`)).addTo(map);
      const b = new window.maplibregl.LngLatBounds();
      b.extend([parkDetail.longitude, parkDetail.latitude]);
      b.extend([cmpDetail.longitude, cmpDetail.latitude]);
      map.fitBounds(b, {padding:60});
    }
    mapInst.current = map;
    return () => { if (mapInst.current) { mapInst.current.remove(); mapInst.current = null; } };
  }, [parkDetail, cmpDetail, tab]);

  const pName = (p) => p?.name_xls || p?.name_kmz || `Park #${p?.park_id}`;
  const fmt = (v) => v != null ? Number(v).toLocaleString('tr-TR') : '-';

  const S = {
    wrap:{display:'flex',height:'calc(100vh - 200px)',background:'#f8fafc',borderRadius:12,overflow:'hidden',border:'1px solid #e2e8f0'},
    side:{width:300,background:'#fff',borderRight:'1px solid #e2e8f0',display:'flex',flexDirection:'column'},
    main:{flex:1,display:'flex',flexDirection:'column',overflow:'hidden'},
    input:{width:'100%',padding:'8px 12px',borderRadius:6,border:'1px solid #d1d5db',fontSize:13,outline:'none',boxSizing:'border-box'},
    btn:(c,d)=>({padding:'8px 16px',borderRadius:8,border:'none',cursor:d?'not-allowed':'pointer',fontSize:13,fontWeight:600,background:d?'#cbd5e1':(c||'#3b82f6'),color:'#fff',opacity:d?.6:1}),
    btnSm:(c)=>({padding:'4px 10px',borderRadius:6,border:'none',cursor:'pointer',fontSize:11,fontWeight:500,background:c||'#3b82f6',color:'#fff'}),
    chip:(a)=>({padding:'6px 14px',borderRadius:20,border:'none',cursor:'pointer',fontSize:12,fontWeight:600,background:a?'#3b82f6':'#f1f5f9',color:a?'#fff':'#64748b'}),
    alert:(t)=>({padding:'10px 14px',borderRadius:8,fontSize:13,background:t==='err'?'#fef2f2':'#f0fdf4',color:t==='err'?'#dc2626':'#16a34a',border:`1px solid ${t==='err'?'#fecaca':'#bbf7d0'}`,marginBottom:12}),
  };

  return (
    <div style={S.wrap}>
      <div style={S.side}>
        <div style={{padding:'16px',borderBottom:'1px solid #e2e8f0'}}>
          <h3 style={{margin:0,fontSize:15,fontWeight:700,color:'#1e293b'}}>Park Yonetimi</h3>
          <p style={{margin:'4px 0 8px',fontSize:11,color:'#64748b'}}>1243 park | Canli DB</p>
          <div style={{display:'flex',gap:6}}>
            <input style={{...S.input,flex:1}} placeholder="Park ara..." value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'){setPg(0);loadParks();}}} />
            <button style={S.btn()} onClick={()=>{setPg(0);loadParks();}}>Ara</button>
          </div>
        </div>
        <div style={{flex:1,overflow:'auto'}}>
          {loading && <p style={{padding:16,color:'#64748b',fontSize:12,textAlign:'center'}}>Yukleniyor...</p>}
          {parks.map(p => {
            const act = selPark === p.park_id;
            return (
              <div key={p.park_id} onClick={()=>loadDetail(p.park_id)} style={{padding:'10px 16px',cursor:'pointer',borderBottom:'1px solid #f1f5f9',background:act?'#eff6ff':'transparent',borderLeft:act?'3px solid #3b82f6':'3px solid transparent'}}>
                <div style={{fontSize:13,fontWeight:act?600:400,color:act?'#1d4ed8':'#334155',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{pName(p)}</div>
                <div style={{fontSize:10,color:'#94a3b8',marginTop:2}}>ID:{p.park_id} | {p.latitude ? `${Number(p.latitude).toFixed(4)}, ${Number(p.longitude).toFixed(4)}` : 'Konum yok'}</div>
                {!act && selPark && cmpPark !== p.park_id && (
                  <button onClick={e=>{e.stopPropagation();loadCmp(p.park_id);setTab('compare');}} style={{...S.btnSm('#6366f1'),marginTop:4,fontSize:10}}>Karsilastir</button>
                )}
                {cmpPark === p.park_id && <span style={{fontSize:10,color:'#6366f1',fontWeight:600}}>Karsilastirma</span>}
              </div>
            );
          })}
          <div style={{display:'flex',justifyContent:'center',gap:8,padding:12}}>
            <button style={S.btnSm(pg===0?'#cbd5e1':'#3b82f6')} onClick={()=>setPg(Math.max(0,pg-1))} disabled={pg===0}>Onceki</button>
            <span style={{fontSize:11,color:'#64748b',padding:'4px 0'}}>Sayfa {pg+1}</span>
            <button style={S.btnSm(parks.length<PS?'#cbd5e1':'#3b82f6')} onClick={()=>setPg(pg+1)} disabled={parks.length<PS}>Sonraki</button>
          </div>
        </div>
      </div>

      <div style={S.main}>
        {error && <div style={{...S.alert('err'),margin:'16px 20px 0'}}>{error}</div>}
        {success && <div style={{...S.alert('ok'),margin:'16px 20px 0'}}>{success}</div>}

        {!selPark ? (
          <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:8}}>
            <span style={{fontSize:48}}></span>
            <h3 style={{color:'#64748b',fontWeight:500}}>Bir park secin</h3>
            <p style={{color:'#94a3b8',fontSize:13}}>Sol panelden park secip detaylari gorun, duzenleyin, haritada acin veya karsilastirin</p>
          </div>
        ) : (
          <>
            <div style={{padding:'12px 20px',background:'#fff',borderBottom:'1px solid #e2e8f0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div>
                <h3 style={{margin:0,fontSize:16,color:'#1e293b'}}>{parkDetail ? pName(parkDetail) : '...'}</h3>
                <p style={{margin:'2px 0 0',fontSize:12,color:'#64748b'}}>ID: {selPark}</p>
              </div>
              <div style={{display:'flex',gap:8}}>
                {!editMode ? (
                  <button style={S.btn('#f59e0b')} onClick={()=>{setEditMode(true);setEditData({...parkDetail})}}>Duzenle</button>
                ) : (
                  <><button style={S.btn('#10b981')} onClick={handleSave}>Kaydet</button><button style={S.btn('#64748b')} onClick={()=>setEditMode(false)}>Iptal</button></>
                )}
              </div>
            </div>
            <div style={{display:'flex',gap:4,padding:'8px 20px',background:'#fff',borderBottom:'1px solid #e2e8f0'}}>
              {[['detail','Detay'],['map','Harita'],['areas','Alanlar'],['compare','Karsilastir']].map(([id,lb])=>(
                <button key={id} style={S.chip(tab===id)} onClick={()=>setTab(id)}>{lb}</button>
              ))}
            </div>
            <div style={{flex:1,overflow:'auto',padding:20}}>
              {tab==='detail' && parkDetail && (
                <div style={{maxWidth:600}}>
                  <div style={{display:'grid',gridTemplateColumns:'140px 1fr',gap:'10px 16px',alignItems:'center'}}>
                    {[{k:'park_id',l:'Park ID',ro:true},{k:'name_kmz',l:'KMZ Adi'},{k:'name_xls',l:'Excel Adi'},{k:'latitude',l:'Enlem'},{k:'longitude',l:'Boylam'}].map(f=>[
                      <label key={f.k+'l'} style={{fontSize:13,fontWeight:600,color:'#475569'}}>{f.l}</label>,
                      editMode && !f.ro ? (
                        <input key={f.k+'v'} style={S.input} value={editData[f.k]??''} onChange={e=>setEditData(p=>({...p,[f.k]:e.target.value}))} />
                      ) : (
                        <span key={f.k+'v'} style={{fontSize:13,color:'#334155'}}>{parkDetail[f.k]!=null?String(parkDetail[f.k]):<i style={{color:'#cbd5e1'}}>bos</i>}</span>
                      )
                    ])}
                  </div>
                  {parkSubs.length > 0 && (
                    <div style={{marginTop:24}}>
                      <h4 style={{color:'#1e293b',marginBottom:8,fontSize:14}}>Aboneler</h4>
                      {parkSubs.map((s,i)=>(
                        <div key={i} style={{padding:10,background:'#f8fafc',borderRadius:8,marginBottom:6,border:'1px solid #e2e8f0',fontSize:12}}>
                          <strong>{s.name_aski||s.abone_no}</strong> <span style={{color:'#64748b'}}>({s.subscriber_type||'-'})</span>
                          {s.meter_no && <div style={{color:'#64748b',marginTop:2}}>Sayac: {s.meter_no} | Cap: {s.diameter}mm</div>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              {tab==='map' && (
                parkDetail?.latitude ? <div ref={mapRef} style={{width:'100%',height:'100%',minHeight:450,borderRadius:10,overflow:'hidden'}} />
                : <p style={{color:'#94a3b8',textAlign:'center',padding:60}}>Bu park icin konum bilgisi yok.</p>
              )}
              {tab==='areas' && (
                <div>
                  {parkArea && (
                    <div style={{marginBottom:24}}>
                      <h4 style={{color:'#1e293b',marginBottom:12}}>Alan Dagilimi</h4>
                      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(150px,1fr))',gap:10}}>
                        {[['grass_area_m2','Cim','#22c55e'],['hard_surface_area_m2','Sert Zemin','#64748b'],['playground_area_m2','Oyun Alani','#f59e0b'],['flowerbed_area_m2','Ciceklik','#ec4899'],['walking_paths_area_m2','Yuruyus','#8b5cf6'],['pool_area_m2','Havuz','#06b6d4'],['woodland_area_m2','Agaclik','#166534'],['total_area_m2','TOPLAM','#1e293b']].map(([k,l,c])=>(
                          <div key={k} style={{background:'#fff',borderRadius:8,padding:12,textAlign:'center',border:'1px solid #e2e8f0'}}>
                            <div style={{fontSize:18,fontWeight:700,color:c}}>{fmt(parkArea[k])}</div>
                            <div style={{fontSize:10,color:'#64748b',marginTop:2}}>{l} (m2)</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {parkIrrigation && (
                    <div>
                      <h4 style={{color:'#1e293b',marginBottom:12}}>Sulama</h4>
                      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(170px,1fr))',gap:10}}>
                        {[['area_m2','Alan','#3b82f6'],['irrigated_area_m2','Sulanan','#22c55e'],['auto_irrigation_percent','Oto %','#f59e0b']].map(([k,l,c])=>(
                          <div key={k} style={{background:'#fff',borderRadius:8,padding:12,textAlign:'center',border:'1px solid #e2e8f0'}}>
                            <div style={{fontSize:18,fontWeight:700,color:c}}>{fmt(parkIrrigation[k])}</div>
                            <div style={{fontSize:10,color:'#64748b',marginTop:2}}>{l}</div>
                          </div>
                        ))}
                      </div>
                      {parkIrrigation.irrigation_schedule && <p style={{marginTop:8,fontSize:12,color:'#64748b'}}>Program: {parkIrrigation.irrigation_schedule}</p>}
                    </div>
                  )}
                  {!parkArea && !parkIrrigation && <p style={{color:'#94a3b8',textAlign:'center',padding:40}}>Alan verisi bulunamadi.</p>}
                </div>
              )}
              {tab==='compare' && (
                !cmpDetail ? (
                  <div style={{textAlign:'center',padding:40}}><p style={{color:'#64748b'}}>Sol panelden ikinci park secin (\"Karsilastir\" butonu)</p></div>
                ) : (
                  <div>
                    <div style={{marginBottom:16}}>
                      {parkDetail?.latitude && <div ref={mapRef} style={{width:'100%',height:300,borderRadius:10,overflow:'hidden'}} />}
                    </div>
                    <div style={{display:'grid',gridTemplateColumns:'140px 1fr 1fr',border:'1px solid #e2e8f0',borderRadius:8,overflow:'hidden'}}>
                      <div style={{padding:10,background:'#f8fafc',fontWeight:700,fontSize:12,color:'#475569',borderBottom:'2px solid #e2e8f0'}}></div>
                      <div style={{padding:10,background:'#eff6ff',fontWeight:700,fontSize:12,color:'#1d4ed8',borderBottom:'2px solid #e2e8f0'}}>{pName(parkDetail)}</div>
                      <div style={{padding:10,background:'#f0fdf4',fontWeight:700,fontSize:12,color:'#166534',borderBottom:'2px solid #e2e8f0'}}>{pName(cmpDetail)}</div>
                      {[
                        ['Enlem',parkDetail?.latitude,cmpDetail?.latitude],
                        ['Boylam',parkDetail?.longitude,cmpDetail?.longitude],
                        ...(parkArea ? [
                          ['Cim m2',parkArea?.grass_area_m2,cmpArea?.grass_area_m2],
                          ['Sert Zemin m2',parkArea?.hard_surface_area_m2,cmpArea?.hard_surface_area_m2],
                          ['Toplam m2',parkArea?.total_area_m2,cmpArea?.total_area_m2],
                        ] : []),
                      ].map(([lb,v1,v2],i)=>{
                        const n1=Number(v1||0), n2=Number(v2||0);
                        const bg1 = n1>=n2?'#f0fdf4':'#fef2f2', bg2 = n2>=n1?'#f0fdf4':'#fef2f2';
                        return [
                          <div key={'l'+i} style={{padding:'8px 10px',fontSize:12,fontWeight:500,color:'#475569',borderBottom:'1px solid #f1f5f9',background:'#f8fafc'}}>{lb}</div>,
                          <div key={'a'+i} style={{padding:'8px 10px',fontSize:12,borderBottom:'1px solid #f1f5f9',background:bg1}}>{v1!=null?fmt(v1):'-'}</div>,
                          <div key={'b'+i} style={{padding:'8px 10px',fontSize:12,borderBottom:'1px solid #f1f5f9',background:bg2}}>{v2!=null?fmt(v2):'-'}</div>,
                        ];
                      })}
                    </div>
                    <button style={{...S.btn('#ef4444'),marginTop:16}} onClick={()=>{setCmpPark(null);setCmpDetail(null);setCmpArea(null);}}>Temizle</button>
                  </div>
                )
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ParkManager;
